import React from "react";
import { Mail, Phone, MapPin, Shield } from "lucide-react";

const attorneys = [
  {
    id: "scotti",
    name: "Avv. Giovanna Scotti",
    city: "Chieti (CH)",
    address: "Via Spaventa, 29",
    email: "avvscotti@legaliscottibava.eu",
    pec: "avvgiovannascotti@pec.it",
    phone: "320.1862530",
    bio: "Assiste privati e imprese in materia di diritto del lavoro, diritto civile (locazioni, contratti e recupero crediti) e diritto penale, con esperienza consolidata nella fase conciliativa, stragiudiziale e nel contenzioso.",
  },
  {
    id: "bava",
    name: "Avv. Salvatore Francesco Antonio Bava",
    city: "Bra (CN)",
    address: "Via Provvidenza, 31",
    email: "avvbava@legaliscottibava.eu",
    pec: "dott.salvatorebava@pec.it",
    phone: "380.7895960",
    bio: "Esercita la professione forense nelle materie del diritto del lavoro, del diritto civile (locazioni, contratti, recupero crediti) e del diritto penale, con particolare attenzione al contenzioso individuale. Membro del Foro di Asti.",
  },
];

export default function Attorneys() {
  return (
    <section id="avvocati" data-testid="attorneys-section" className="py-24 md:py-32">
      <div className="container-ed">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="overline mb-6">Gli Avvocati</div>
          <h2 className="serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0F172A]">
            Due professionisti, <span className="italic text-[#A38A5A]">un'unica dedizione</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {attorneys.map((a) => (
            <article
              key={a.id}
              data-testid={`attorney-${a.id}`}
              className="group bg-white border border-black/10 p-8 md:p-10 transition-shadow duration-300 hover:shadow-xl"
            >
              <div className="flex items-start justify-between gap-4 mb-8">
                <div className="overline text-[10px]">{a.city}</div>
                <div className="h-10 w-10 rounded-full bg-[#FDFBF7] border border-black/10 flex items-center justify-center">
                  <Shield className="w-4 h-4 text-[#A38A5A]" strokeWidth={1.5} />
                </div>
              </div>

              <h3 className="serif text-3xl md:text-4xl leading-tight text-[#0F172A]">
                {a.name}
              </h3>
              <p className="mt-5 text-sm md:text-base leading-relaxed text-[#57534E]">{a.bio}</p>

              <div className="mt-8 hairline pt-6 space-y-3 text-sm">
                <div className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 mt-0.5 text-[#A38A5A] shrink-0" strokeWidth={1.5} />
                  <span className="text-[#1C1917]">
                    {a.address} — {a.city}
                  </span>
                </div>
                <a
                  href={`tel:${a.phone.replace(/\./g, "")}`}
                  data-testid={`attorney-${a.id}-phone`}
                  className="flex items-start gap-3 text-[#1C1917] hover:text-[#A38A5A] transition-colors"
                >
                  <Phone className="w-4 h-4 mt-0.5 text-[#A38A5A] shrink-0" strokeWidth={1.5} />
                  <span>{a.phone}</span>
                </a>
                <a
                  href={`mailto:${a.email}`}
                  data-testid={`attorney-${a.id}-email`}
                  className="flex items-start gap-3 text-[#1C1917] hover:text-[#A38A5A] transition-colors break-all"
                >
                  <Mail className="w-4 h-4 mt-0.5 text-[#A38A5A] shrink-0" strokeWidth={1.5} />
                  <span>{a.email}</span>
                </a>
                <a
                  href={`mailto:${a.pec}`}
                  data-testid={`attorney-${a.id}-pec`}
                  className="flex items-start gap-3 text-[#57534E] hover:text-[#A38A5A] transition-colors break-all"
                >
                  <Mail className="w-4 h-4 mt-0.5 text-[#A38A5A]/70 shrink-0" strokeWidth={1.5} />
                  <span>
                    <span className="overline text-[10px]">PEC</span>
                    <span aria-hidden="true">{"\u00A0\u00A0"}</span>
                    {a.pec}
                  </span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
